import { v4 as uuidv4 } from 'uuid';
import { useSelector } from 'react-redux';
import { getStateValByLS } from './pageEditor/common';
const useCampignEventTrace = () => {
  const { getCommonData } = getStateValByLS();
  const commonData = getCommonData();

  const { userProfile } = commonData;
  const campaignReferrerPage = userProfile?.refererPage;
  const ctaId = userProfile?.ctaId;
  const utmId = userProfile?.utmId;
  const utmCampaign = userProfile?.utmCampaign;
  const utmMedium = userProfile?.utmMedium;
  const utmSource = userProfile?.utmSource;
  const utmContent = userProfile?.utmContent;
  const utmTerm = userProfile?.utmTerm;

  // const campaignReferrerPage = useSelector((state) => state.commonData?.userProfile?.refererPage);
  // const ctaId = useSelector((state) => state.commonData?.userProfile?.ctaId);
  // const utmId = useSelector((state) => state.commonData?.userProfile?.utmId);
  // const utmCampaign = useSelector((state) => state.commonData?.userProfile?.utmCampaign);
  // const utmMedium = useSelector((state) => state.commonData?.userProfile?.utmMedium);
  // const utmSource = useSelector((state) => state.commonData?.userProfile?.utmSource);
  // const utmContent = useSelector((state) => state.commonData?.userProfile?.utmContent);
  // const utmTerm = useSelector((state) => state.commonData?.userProfile?.utmTerm);

  // let uniqueId = sessionStorage.getItem('uniqueId')
  // if (!uniqueId) {
  //     uniqueId = uuidv4();
  //     sessionStorage.setItem('uniqueId', uniqueId);
  //   }
  const getDefaultCampignReqConfig = () => {
    //   const requestId = uuidv4(); // Generate a unique ID for each request
    const delimiter = '~';

    const requestConfig = {
      campaignReferrerPage,
      ctaId,
      utmId,
      utmCampaign,
      utmMedium,
      utmSource,
      utmContent,
      utmTerm,
      // requestId,
      // uniqueId,
    };

    const requestConfigString = Object.values(requestConfig).join(delimiter);
    return requestConfigString;
  };

  return { getDefaultCampignReqConfig };
};

export default useCampignEventTrace;
